var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckAlt = function SvgCheckAlt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35283 0.938494C7.66525 1.25091 7.66525 1.75744 7.35283 2.06986L4.06999 5.35271C3.75757 5.66513 3.25104 5.66513 2.93862 5.35271L0.655773 3.06986C0.343354 2.75745 0.343354 2.25091 0.655773 1.93849L0.938616 1.65565C1.25104 1.34323 1.75757 1.34323 2.06999 1.65565L3.36288 2.94854C3.44098 3.02665 3.56762 3.02665 3.64572 2.94854L5.93862 0.655651C6.25104 0.343232 6.75757 0.343232 7.06999 0.655651L7.35283 0.938494Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckAlt);
export { ForwardRef as ReactComponent };